export enum Mutations {
    saveRecommendedProgram = 'saveRecommendedProgram',
    deleteRecommendedProgram = 'deleteRecommendedProgram',
    changeRecommendedProgramStatus = 'changeRecommendedProgramStatus',
}
